import React from "react";
import { useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import AppContext from "../../AppContext";
import { formatDate } from "@telerik/kendo-intl";
import {
  BASE_URL,
  Severities,
  alarmStatuses,
  formatAlarmValue,
} from "../../constant";
import axios from "axios";
import { useParams } from "react-router";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import ColumnMenuFilter from "./ColumnMenuFilter";
import { Tooltip } from "@progress/kendo-react-tooltip";
import KendoLoadingPanel from "../KendoLoadingPanel";
import { useImperativeHandle } from "react";
import { forwardRef } from "react";
import { useTranslation } from "react-i18next";

const AlarmHistoryTable = forwardRef(
  ({ asset, playBackMode, expanded, momentData, mode, assetId }, ref) => {
    const { getTimeZoneDateTime, darkMode } = useContext(AppContext);
    const RenderCell = (props) => {
      const { field, dataItem } = props;
      const {
        id,
        sensorId,
        status,
        sensorValue,
        timeStamp,
        acknowledgeUser,
        clearedUser,
        actionTime,
        alarmType,
        sensorType,
        alarmName,
      } = dataItem;

      const renderSensorName = () => <div>{alarmName}</div>;
      const renderSeverity = () => (
        <div className="flex gap-2 justify-start items-center">
          <img
            src={Severities.find((x) => x.value === status).icon}
            alt="Severity_Icon"
            className={`${
              Severities.find((x) => x.value === status).color
            } rounded-full w-5 h-5 p-1 border`}
          />
          {Severities.find((x) => x.value === status).label}
        </div>
      );
      const renderTimeStamp = () =>
        formatDate(getTimeZoneDateTime(timeStamp), "dd-MMM-yyyy hh:mm a");
      const renderActionTime = () =>
        actionTime !== undefined ??
        formatDate(getTimeZoneDateTime(timeStamp), "dd-MMM-yyyy hh:mm a");
      const renderValue = () => (
        <div>
          {formatAlarmValue(alarmType, sensorValue, "flex-col", sensorType)}
          &nbsp;
          {getSensorName(sensorId)?.unit}
        </div>
      );
      const renderStatus = () => {
        return clearedUser
          ? "Closed"
          : acknowledgeUser
          ? "Acknowledged"
          : "Open";
      };
      const renderAction = () =>
        !acknowledgeUser ? (
          <button
            type="button"
            className="border-lime-600 historytable tooltip border h-7 w-7 mx-auto flex justify-center items-center rounded-full disabled:opacity-30"
            onClick={() => updateAlarm(id, "acknowledge")}
            disabled={id === disabledButtonAlarms}
          >
            <img
              src="Acknowledge-icon.svg"
              title="Acknowledge"
              alt="acknowledge"
            />
            {/* <div className="tooltiptext z-100">Acknowledge</div> */}
          </button>
        ) : !clearedUser ? (
          <button
            type="button"
            className="disabled:opacity-30 mx-auto w-full"
            onClick={() => updateAlarm(id, "clear")}
            disabled={id === disabledButtonAlarms}
          >
            <img
              src="clear-icon.svg"
              alt="clear"
              title="Close"
              className="h-5 mx-auto"
            />
          </button>
        ) : (
          <div title="Closed">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="green"
              class="w-6 h-6 mx-auto"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z"
              />
            </svg>
          </div>
        );

      const fieldRenderers = {
        sensorId: renderSensorName,
        severity: renderSeverity,
        sensorValue: renderValue,
        timeStamp: renderTimeStamp,
        actionTime: renderActionTime,
        status: renderStatus,
        action: renderAction,
      };
      const content = fieldRenderers[field]();

      return <td className="px-2 py-3">{content}</td>;
    };

    const [filterData, setFilterData] = useState({
      sensorName: "",
      severity: [],
      sensorValue: { operator: "=", value: null },
      status: [],
      timeStamp: { start: null, end: null },
    });
    const { t } = useTranslation();
    const columns = [
      {
        field: "alarmName",
        title: t("assetDetails.table.tableHeaders.sensorName"),
        width: "auto",
        show: true,
        filterable: true,
        columnMenuType: "textbox",
      },
      {
        field: "severity",
        title: t("assetDetails.table.tableHeaders.severity"),
        width: 100,
        filterable: true,
        show: true,
        columnMenuType: "dropdown",
        columnMenuData: Severities,
        cell: RenderCell,
      },
      {
        field: "sensorValue",
        title: t("assetDetails.table.tableHeaders.sensorValue"),
        width: 100,
        show: true,
        filterable: true,
        cell: RenderCell,
        columnMenuType: "number",
      },
      {
        field: "timeStamp",
        title: t("assetDetails.table.tableHeaders.timeStamp"),
        width: "auto",
        filterable: true,
        show: true,
        cell: RenderCell,
        columnMenuType: "date",
      },

      {
        field: "status",
        title: t("assetDetails.table.tableHeaders.status"),
        width: "auto",
        filterable: true,
        show: true,
        columnMenuType: "dropdown",
        columnMenuData: alarmStatuses,
        cell: RenderCell,
      },
      {
        field: "action",
        title: t("assetDetails.table.tableHeaders.action"),
        width: 70,
        show: playBackMode === 100,
        filterable: false,
        cell: RenderCell,
      },
    ];
    const { alarm, authCtx, updatedAlarm } = useContext(AppContext);
    const [historyData, setHistoryData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [disabledButtonAlarms, setDisabledButtonAlarms] = useState();
    const [loading, setLoading] = useState(false);

    useImperativeHandle(ref, () => ({
      clearChildState() {
        setHistoryData([]);
        setFilteredData([]);
      },
    }));

    const getSensorName = (sensor) => {
      const data = asset.parameters.find((p) => p.sensorId === sensor);
      return data;
    };

    const getLatestData = async () => {
      setLoading(true);
      const cTime = new Date();
      const lastHour = new Date(cTime.getTime() - mode.table * 60 * 60 * 1000)
        .toISOString()
        .slice(0, 23);
      const res = await axios.get(
        `${BASE_URL}/AssetAlarm/GetAlarmsByAssetId?assetId=${assetId}&startTime=${lastHour}&endTime=${cTime
          .toISOString()
          .slice(0, 23)}`
      );
      if (res.status === 200) {
        const finalData = res.data.map((x) => ({
          ...x,
          sensorName: getSensorName(x.sensorId)?.name,
          actionTime: x.timeStamp,
          sensorType: getSensorName(x.sensorId)?.type,
        }));
        setHistoryData(finalData);
        setFilteredData(finalData);
      }
      setLoading(false);
    };

    useEffect(() => {
      if (playBackMode === 100 && mode.table !== null) getLatestData();
    }, [mode.table, playBackMode]);

    const updateAlarm = async (id, buttonType) => {
      const alarm = historyData.find((a) => a.id === id);
      if (!alarm) {
        return;
      }

      const updateItem = {
        alarms: [{ key: alarm.timeStamp, id: alarm.id }],
        buttonType,
        user: authCtx.profile.name,
        time: new Date(),
      };
      setDisabledButtonAlarms(id);

      let res = await axios.post(
        `${BASE_URL}/AssetAlarm/UpdateAlarmAction`,
        updateItem
      );

      if (res.status === 200) {
        if (buttonType === "clear") {
          const finalAlarms = historyData.filter((a) => a.id !== id);
          setHistoryData(finalAlarms);
          setFilteredData(finalAlarms);
        }
      }

      setDisabledButtonAlarms(null);
    };

    const filterDataByFilter = (latestData, filterState) => {
      const selectedStatuses = filterState.status.map((x) => x.value);

      const finalData = latestData
        .filter((x) => {
          if (filterState.sensorName !== "") {
            return x.sensorName
              .toLowerCase()
              .includes(filterState.sensorName.toLowerCase());
          }
          return true; // No filter applied for sensorName if it's in the default state
        })
        .filter((x) => {
          if (filterState.severity.length > 0) {
            return filterState.severity.some(
              (severity) => severity.value === x.status
            );
          }
          return true; // No filter applied for severity if it's in the default state
        })
        .filter((x) => {
          if (
            filterState.sensorValue.value !== null &&
            filterState.sensorValue.operator !== "" // Check if operator is not in default state
          ) {
            const parsedValue = parseFloat(x.sensorValue?.toFixed(2));
            if (filterState.sensorValue.operator === "=") {
              return parsedValue === parseFloat(filterState.sensorValue.value);
            } else if (filterState.sensorValue.operator === ">") {
              return parsedValue > filterState.sensorValue.value;
            } else if (filterState.sensorValue.operator === "<") {
              return parsedValue < filterState.sensorValue.value;
            }
          }
          return true; // No filter applied for sensorValue if it's in the default state
        })
        .filter((x) => {
          if (selectedStatuses.length > 0) {
            return (
              (selectedStatuses.includes("acknowledged") &&
                x.acknowledgeUser !== null) ||
              (selectedStatuses.includes("closed") && x.clearedUser !== null) ||
              (selectedStatuses.includes("open") && x.acknowledgeUser === null)
            );
          }
          return true; // No filter applied for status if it's in the default state
        })
        .filter((x) => {
          if (
            filterState.timeStamp.start !== null ||
            filterState.timeStamp.end !== null
          ) {
            return (
              (filterState.timeStamp.start === null ||
                new Date(x.timeStamp) >=
                  new Date(filterState.timeStamp.start)) &&
              (filterState.timeStamp.end === null ||
                new Date(x.timeStamp) <= new Date(filterState.timeStamp.end))
            );
          }
          return true; // No filter applied for timeStamp if it's in the default state
        });
      setFilteredData(finalData);
    };

    useEffect(() => {
      if (historyData.length > 0) {
        filterDataByFilter(historyData, filterData);
      }
    }, [filterData]);

    useEffect(() => {
      if (updatedAlarm && updatedAlarm.Alarms) {
        const updateFields = {
          clear: {
            clearedTime: updatedAlarm.Time,
            clearedUser: updatedAlarm.User,
          },
          acknowledge: {
            acknowledgeTime: updatedAlarm.Time,
            acknowledgeUser: updatedAlarm.User,
          },
        };
        const updateData = (data) => {
          return data
            .map((item) => {
              const updateAlarm = updatedAlarm.Alarms.find(
                (a) => a.Id === item.id
              );
              return updateAlarm
                ? { ...item, ...updateFields[updatedAlarm.ButtonType] }
                : item;
            })
            .filter((item) => !item.clearedUser);
        };

        setHistoryData((prev) => updateData(prev));
        setFilteredData((prev) => updateData(prev));
      }
    }, [updatedAlarm]);

    const renderData = (alarmData, clearData) => {
      const data = alarmData.filter((x) => x.assetId === assetId).flat();

      const addSensorName = (currentData) =>
        currentData.map((item) => ({
          ...item,
          sensorName: getSensorName(item.sensorId)?.name,
        }));

      const modifiedData = addSensorName(data);

      if (clearData) {
        const finalData = modifiedData.sort(
          (a, b) => new Date(b.timeStamp) - new Date(a.timeStamp)
        );
        setHistoryData(finalData);
        setFilteredData(finalData);
      } else {
        setHistoryData((prev) => {
          const modifiedData = addSensorName(data.concat(prev));
          const finalData = modifiedData.sort(
            (a, b) => new Date(b.timeStamp) - new Date(a.timeStamp)
          );
          filterDataByFilter(finalData, filterData);
          return finalData;
        });
      }
    };

    useEffect(() => {
      if (playBackMode === 200) {
        if (momentData)
          if (momentData.dragging) {
            if (momentData.rangeAlarms.length === 0) {
              setHistoryData([]);
              setFilteredData([]);
            } else renderData(momentData.rangeAlarms, true);
          } else {
            if (momentData?.alarms) renderData(momentData.alarms, false);
          }
      }
    }, [momentData?.alarms]);

    useEffect(() => {
      if (playBackMode === 100 && alarm.length > 0) {
        renderData(alarm, false);
      }
    }, [alarm]);

    return (
      <>
        <div
          className={`${expanded === "table" ? "h-5/6" : "md:h-[87%] h-72"} ${
            darkMode ? "darkGrid" : "lightGrid"
          } overflow-x-auto overflow-y-hidden relative border rounded-2xl border-zinc-800 shadow-md`}
        >
          {loading && <KendoLoadingPanel />}
          <Tooltip
            anchorElement="target"
            style={{ backgroundColor: "#434343" }}
            openDelay={100}
          >
            <Grid
              style={{
                height: "100%",
                width: "100%",
                backgroundColor: "#181921",
                borderRadius: "15px",
                textAlign: "justify",
                overflow: "auto",
              }}
              data={filteredData}
              scrollable="scrollable"
            >
              {columns.map(
                (column, idx) =>
                  column.show && (
                    <GridColumn
                      key={idx}
                      field={column.field}
                      title={column.title}
                      filterable={column.filterable}
                      cell={column.cell}
                      width={column.width}
                      filter={column.filter}
                      columnMenu={
                        column.filterable
                          ? (props) =>
                              ColumnMenuFilter({
                                ...props,
                                type: column.columnMenuType,
                                data: column.columnMenuData,
                                setFilterData,
                                filterData,
                              })
                          : null
                      }
                    />
                  )
              )}
            </Grid>
          </Tooltip>
        </div>
      </>
    );
  }
);

export default AlarmHistoryTable;
